import ErrorRendererComponent from './error-renderer.component'

export default ErrorRendererComponent
